import React from 'react';
import { useNavigate } from 'react-router-dom';
import SammiLogo from '../components/common/SammiLogo';
import Button from '../components/common/Button';
import { useTranslation } from 'react-i18next';

export const WelcomePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleCreateOrgClick = () => {
    // TODO: STEP 2 - Navigate to organization registration
    navigate('/register-org');
  };

  return (
    <div 
      className="flex flex-col items-center justify-center min-h-screen px-4"
      style={{
        background: 'linear-gradient(135deg, rgba(25, 183, 223, 0.75) 0%, rgba(65, 239, 170, 0.75) 100%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}
    >
      <div className="flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12 w-full max-w-md mx-auto">
        <SammiLogo size="large" className="mb-8" />
        
        <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center leading-tight">
          Smart Monitoring Starts Here
        </h2>
        
        <div className="flex flex-col w-full space-y-4">
          <Button variant="primary" onClick={handleLoginClick}>
            Login to an existing organization
          </Button>
          
          <Button variant="outline" onClick={handleCreateOrgClick}>
            Create a new organization
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
